module.exports = __webpack_public_path__ + "img/home-background.ad05aecd.svg";